import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { PropertyDto, PropertyKeyInfoDto } from '@workspace/data-types';
import { DtoChangedDetection } from '@workspace/ng-aura';
import { PropertyKeyInfosDisplayComponent } from '../display/key-infos-display.component';
import { PropertyKeyInfosFormComponent } from '../form/key-infos-form.component';

@Component({
  selector: 'etxe-property-key-infos-edit',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    PropertyKeyInfosDisplayComponent,
    PropertyKeyInfosFormComponent,
  ],
  templateUrl: './key-infos-edit.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PropertyKeyInfosEditComponent {
  property = input.required<PropertyDto>();
  editMode = input.required<boolean>();
  editable = input<boolean>(true);
  saving = input<boolean>(false);

  editToggled = output<void>();
  cancelToggled = output<void>();
  dtoChanged = output<DtoChangedDetection<PropertyKeyInfoDto>>();
  submitted = output<void>();

  onEdit() {
    this.editToggled.emit();
  }

  onCancel() {
    this.cancelToggled.emit();
  }

  onDtoChanged(event: DtoChangedDetection<PropertyKeyInfoDto>) {
    this.dtoChanged.emit(event);
  }

  onSubmit() {
    this.submitted.emit();
  }
}
